import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { assertAuthenticated } from "@/utilities/auth/assertAuthenticated"
import welcomeTokenStorage from "@/utilities/WelcomeTokenStorage"

export const Route = createFileRoute("/qr/$qrLookupID/_authenticated")({
  /**
   * The parent `/qr/$qrLookupID` loader sets white-label theme mode and
   * cascades, so it is not repeated here.
   */
  beforeLoad: ({ context, params, location }) => {
    /**
     * The parent `/qr/$qrLookupID` guard exempts this subtree, so the stale-QR
     * check lives here. Redirects to the *stored* QR, not `params.qrLookupID` —
     * a bad value can't mint a token and would strand the user.
     *
     * This runs before the auth check on purpose: a stale QR discards the
     * destination either way, so gating on auth first would send the user
     * through a sign-in they gain nothing from.
     */
    if (!welcomeTokenStorage.validateQrLookupID(params.qrLookupID)) {
      const storedQrLookupID = welcomeTokenStorage.getQrLookupID()
      if (storedQrLookupID) {
        throw redirect({
          to: "/qr/$qrLookupID/welcome",
          params: { qrLookupID: storedQrLookupID },
        })
      }
    }

    assertAuthenticated({
      isAuthenticated: context.isAuthenticated,
      redirectHref: location.href,
      qrLookupID: params.qrLookupID,
    })
  },
  component: Outlet,
})
